// Shared color vocabulary for alert-ish surfaces (Toaster, SoftGateBanner,
// GatingModal). Previously each hand-rolled its own literals for what is
// semantically the same success/error/warning/info language, and they'd
// already drifted. Toaster's values were the most complete, so they're the
// canonical source here — extend/replace with real design tokens if
// styles/tokens.css grows dedicated alert tokens later.
export const ALERT_STYLES = {
  success: {
    background: 'linear-gradient(135deg, #1a3d2a, #0f1f18)',
    border: '1px solid rgba(61, 255, 154, 0.5)',
    color: '#3dff9a',
    boxShadow: '0 0 24px rgba(61, 255, 154, 0.15)',
  },
  error: {
    background: 'linear-gradient(135deg, #3d1520, #1a0a10)',
    border: '1px solid rgba(255, 77, 109, 0.55)',
    color: '#ffb0a0',
    boxShadow: '0 0 24px rgba(255, 77, 109, 0.15)',
  },
  warning: {
    background: 'linear-gradient(135deg, #3d3010, #1a1508)',
    border: '1px solid rgba(255, 197, 61, 0.5)',
    color: '#ffc53d',
    boxShadow: '0 0 24px rgba(255, 197, 61, 0.12)',
  },
  info: {
    background: 'linear-gradient(135deg, #2a180c, #100a06)',
    border: '1px solid rgba(255, 90, 31, 0.45)',
    color: '#ffb080',
    boxShadow: '0 0 24px rgba(255, 90, 31, 0.18)',
  },
};
